/**
 * 商品企画メンテナンス画面Input用VOクラス
 *
 * @export KYMW0900InputModel
 * @class KYMW0900InputModel
 */
export class KYMW0900InputModel {

  // 商品台帳マークコード
  public orderCode: string = <string>'';
  // Ｐコード
  public pCodeList: Array<any> = new Array<any>();
  // 媒体区分
  public MediumType: string = <string>'';
  // ユーザ権限
  public UserPermission: string = <string>'';
  // ロック情報
  public lockInfo: string = <string>'';
  // 束ね企画回の終了受注コード
  public bundleCatalogOrderCode = <string>'';
}
